import * as R from 'ramda';

const makeQuestionClone = R.compose(
  JSON.parse,
  JSON.stringify
);

export default makeQuestionClone;
